const isCSSVar = (name) => name.startsWith("--");

export { isCSSVar };
const isCSSVar = (name) => name.startsWith("--");

export { isCSSVar };
